<template>
	<div>
		<ja-tooltip
			v-show="showDragHelp"
			ref="dragHelp"
			:class="['tooltip', 'drag-tooltip', { 'skip-disable': true }]"
			aria-activedescendant="drag-tooltip-text"
			:pointer="false"
			tabindex="0"
		>
			<h1 id="drag-tooltip-text" class="body-text-1">
				{{ $t('dragHelp') }}
			</h1>
			<ja-button
				:class="['small', 'transparent', { 'skip-disable': true }]"
				name="drag-help"
				:aria-label="$t('goNextOnboardingStep')"
				@click.native="onDragHelpRead"
				>{{ $t('okay') }}</ja-button
			>
		</ja-tooltip>
		<ja-tooltip
			v-show="showZoomHelp"
			ref="zoomHelp"
			:class="['tooltip', 'zoom-tooltip', 'right', { 'skip-disable': true }]"
			aria-activedescendant="zoom-tooltip-text"
			tabindex="0"
			@click.native.once="onZoomHelpRead"
		>
			<h1 id="zoom-tooltip-text" class="body-text-1">
				{{ $t('zoomHelp') }}
			</h1>
			<ja-button
				:class="['small', 'transparent', { 'skip-disable': true }]"
				name="zoom-help"
				:aria-label="$t('finishOnboarding')"
				>{{ $t('okay') }}</ja-button
			>
		</ja-tooltip>
	</div>
</template>
<script>
import Button from '../ui/Button';
import Tooltip from '../ui/Tooltip';
import gql from 'graphql-tag';

export default {
	components: {
		jaTooltip: Tooltip,
		jaButton: Button
	},
	data() {
		return {
			showDragHelp: true,
			showZoomHelp: false,
			isVisible: false
		};
	},
	computed: {
		userData() {
			return this.$store.getters.userData;
		}
	},
	mounted() {
		if (this.showDragHelp) {
			this.$refs.dragHelp.$el.focus();
		}
	},
	methods: {
		onDragHelpRead() {
			this.showDragHelp = false;
			this.showZoomHelp = true;

			this.$refs.zoomHelp.$el.focus();
		},

		onZoomHelpRead() {
			this.showZoomHelp = false;

			this.hideCalendarTooltips();
			this.$emit('tutorialEnded');
		},

		async hideCalendarTooltips() {
			const tooltipsStatusInfo = {
				id: this.userData.studentId,
				hideCalendarTutorialPopup: true
			};

			const response = await this.$apollo.mutate({
				mutation: gql`
					mutation($update: StudentInputObjectGraphType!) {
						updateIgnoreNullValuesStudent(update: $update) {
							id
						}
					}
				`,
				variables: {
					update: tooltipsStatusInfo
				}
			});
			if (response.data) {
				this.modalIsEnabledFromBE = false;
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.tooltip {
	width: 300px;
	height: 134px;
	text-align: center;
	outline: 0;

	@media (min-width: $breakpoint-mid) {
		width: 360px;
	}

	h1 {
		margin: 0;
	}

	&.drag-tooltip {
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		margin: auto;
	}

	&.zoom-tooltip {
		top: 24px;
		right: 84px;
	}

	.body-text-1 {
		width: 100%;
		padding: 8px;
	}

	button {
		margin-top: 8px;
	}
}
</style>
